import { render, staticRenderFns } from "./MailboxCharts.vue?vue&type=template&id=6a3aba59&scoped=true&"
import script from "./MailboxCharts.vue?vue&type=script&lang=js&"
export * from "./MailboxCharts.vue?vue&type=script&lang=js&"
import style0 from "./MailboxCharts.vue?vue&type=style&index=0&id=6a3aba59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3aba59",
  null
  
)

export default component.exports